import { Candle, CandleResponse } from '../types'

export const candlesResponseMapper = (candles: CandleResponse[]): Candle[] => {
  return candles.map(c => ({
    time: c.t,
    low: c.l,
    high: c.h,
    open: c.o,
    close: c.c,
    volume: c.v,
  }))
}
